module.exports = __webpack_public_path__ + "img/Pencil.584206d7.svg";